module.exports = __webpack_public_path__ + "media/roomBgm.610eb033.mp3";